import React, { useState, useEffect } from 'react';
import '../styles/components/list.css';

const ListItem = ({
  item,
  isChecked = false,
  onCheck,
  onClick,
  className = '',
  showCheckbox = true,
  columnWidths = null
}) => {
  const [checked, setChecked] = useState(isChecked);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const handleCheckboxClick = (e) => {
    e.stopPropagation();
    const newChecked = !checked;
    setChecked(newChecked);
    
    if (onCheck) {
      onCheck(newChecked);
    }
  };

  const handleItemClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <div
      className={`list-item ${className} ${onClick ? 'clickable' : ''}`}
      onClick={handleItemClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      {showCheckbox && (
        <div 
          className={`list-cell ${columnWidths ? 'list-cell-fixed-width' : ''}`}
          style={columnWidths ? { width: '60px' } : {}}
        >
          <div
            className={`patrol-list-checkbox ${checked ? 'checked' : ''}`}
            onClick={handleCheckboxClick}
          >
          </div>
        </div>
      )}
{Object.entries(item).map(([key, value], index) => {
  if (key.startsWith('_')) return null;
  return (
    <div 
      key={index} 
      className={`list-cell ${columnWidths ? 'list-cell-fixed-width' : ''}`}  
      style={columnWidths ? { width: columnWidths[index] } : {}} 
    >
      {value}
    </div>
  );
})}
    </div>
  );
};

export default ListItem;